import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import createPostArea from './utils/createPostArea';
import customiseDiscussionListItem from './utils/customiseDiscussionListItem';
import type ItemList from 'flarum/common/utils/ItemList';
import type Mithril from 'mithril';

app.initializers.add('brickrr/theme', () => {
  createPostArea();

  extend(DiscussionControls, 'userControls', (items: ItemList<Mithril.Children>) => {
    if (items.has('bookmark')) {
      items.remove('bookmark');
    }
  });

  customiseDiscussionListItem();
});
